import React, { useContext, useEffect, useState } from 'react'
import { Context } from '../Context/Context'
import close from '../Components/Images/x-close.png';
import menus from '../Components/Images/menu.png';
import SendBarFromBeneficiary from './SendBarFromBeneficiary';
import refresh from '../Components/Images/refresh.svg'

const ViewDetailsBar = ({ setSendErrorBar, setOpenSendBar }) => {

    const { handleViewDetails, viewDetails, handleDeleteProfile, handleSendBarFromBeneficiary } = useContext(Context)

    const [BenficairyDetails, setBenficairyDetails] = useState(null)
    const [Benficiary, setBenficiary] = useState([])
    const [paymentMade, setPaymentMade] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const BeneficiaryAcctStatus = JSON.parse(localStorage.getItem('BeneficiaryAcctStatus'))

    const fetchBenStatus = async () => {
        const token = localStorage.getItem('token');
        const BeneficairyID = localStorage.getItem('BeneficairyID');
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/beneficiary/${BeneficairyID}/status`, {
                method: "GET",
                headers: {
                    Authorization: `Token ${token}`,
                },
            });
            const text = await res.text();
            const data = JSON.parse(text);
            localStorage.setItem('BeneficiaryAcctStatus', JSON.stringify(data))
        } catch (error) {
            console.error("Error fetching statuses:", error);
        }
    };

    const fetchAll = async () => {
        const token = localStorage.getItem('token');
        const BeneficairyID = localStorage.getItem('BeneficairyID');

        setIsLoading(true);
        setPaymentMade(null);
        setBenficiary([]);
        setBenficairyDetails(null);

        try {
            const res1 = await fetch(`${process.env.REACT_APP_BACKEND_URL}/beneficiary/${BeneficairyID}`, {
                method: "GET",
                headers: {
                    Authorization: `Token ${token}`,
                },
            });
            const beneficiaryData = await res1.json();
            setBenficairyDetails(beneficiaryData);
            setBenficiary(beneficiaryData);

            const res2 = await fetch(`${process.env.REACT_APP_BACKEND_URL}/transactions`, {
                method: "GET",
                headers: {
                    Authorization: `Token ${token}`,
                },
            });
            const transactionData = await res2.json();

            const matchingTransactions = Array.isArray(transactionData)
                ? transactionData.filter((t) => t?.payment?.beneficiary?.id === beneficiaryData.id)
                : [];

            setPaymentMade(matchingTransactions);
        } catch (err) {
            console.error("Failed to fetch beneficiary or transactions:", err);
            setPaymentMade([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (viewDetails) {
            fetchBenStatus();
            fetchAll();
        }
    }, [viewDetails]);


    const handleBeneficairyClick = (id) => {
        localStorage.setItem('BeneficairyID', id);
    };

    return (
        <div className={`fixed top-0 h-screen bg-white lg:p-10 py-8 px-3 duration-700 text-black z-50 overflow-auto ${viewDetails ? 'sm:w-[510px] w-full right-0' : 'right-[-100%] w-[40%]'}`}>
            {isLoading || paymentMade === null ? (
                <div className="flex items-center justify-center h-full">
                    <p className="text-lg font-medium text-[#531CB3]">Loading beneficiary details...</p>
                </div>
            ) : (
                <>
                    <div className='flex gap-2 justify-between'>
                        <div>
                            <div className='flex items-center gap-2'>
                                {paymentMade?.length > 0 && paymentMade[0].payment && paymentMade[0].payment.beneficiary && paymentMade[0].payment.beneficiary.full_name ? (
                                    <h1 className='text-[20px] font-medium text-[#1D1C1F]'>
                                        {paymentMade[0].payment.beneficiary.full_name}
                                    </h1>
                                ) : (
                                    <h1 className='text-[20px] font-medium text-[#1D1C1F]'>
                                        {BenficairyDetails?.full_name || "No name available"}
                                    </h1>
                                )}
                                <img
                                    src={refresh}
                                    alt=""
                                    onClick={() => {
                                        fetchBenStatus();
                                        fetchAll();
                                    }}
                                    className='cursor-pointer'
                                />
                            </div>
                            <div className='mt-2 flex gap-2'>
                                Account Status:
                                <p className={BeneficiaryAcctStatus?.status === 'APPROVED' ? 'bg-green-200 text-green-500 p-1 px-2 rounded-full text-[14px]' : 'bg-red-200 text-red-500 p-1 px-2 rounded-full text-[14px]'}>
                                    {BeneficiaryAcctStatus?.status === 'APPROVED' ? 'Approved' : 'Not Approved'}
                                </p>
                            </div>
                        </div>
                        <img
                            className='size-5 mt-1 cursor-pointer' src={close} alt=""
                            onClick={handleViewDetails}
                        />
                    </div>
                    <div className='flex gap-2 mt-5'>
                        <button
                            onClick={() => {
                                handleDeleteProfile()
                                handleBeneficairyClick(BenficairyDetails.id)
                            }}
                            className='p-2 px-3 text-[14px] border-[1.2px] rounded-lg'
                        >
                            Delete Profile
                        </button>
                        {/* <button
                            onClick={() => {
                                handleProfileEdit()
                                handleBeneficairyClick(BenficairyDetails.id)
                                handleViewDetails()
                            }}
                            className='p-2 px-3 text-[14px] bg-[#E8E1F5] text-[#531CB3] border rounded-lg'
                        >
                            Edit Profile
                        </button> */}
                        <button
                            onClick={() => {
                                handleViewDetails()
                                handleSendBarFromBeneficiary()
                            }}
                            className='p-2 px-3 text-[14px] bg-[#531CB3] text-white border rounded-lg'
                        >
                            Send Money
                        </button>
                    </div>
                    {paymentMade && paymentMade?.length > 0 ? (
                        <div>
                            <div className='mt-7 border rounded-lg p-5 flex flex-col gap-3'>
                                <p className='text-[18px] font-medium text-[#302F33]'>Summary</p>
                                <div className='flex justify-between'>
                                    <div className='flex flex-col gap-2'>
                                        <p className='text-[#525154]'>Amount Sent</p>
                                        <p className='text-[#1D1C1F] text-[20px] font-semibold'>
                                            ${paymentMade.reduce((sum, payment) => sum + Number(payment.amount), 0).toFixed(2)}
                                        </p>
                                    </div>
                                    <div className='flex flex-col gap-2'>
                                        <p className='text-[#525154]'>Number of Transactions</p>
                                        <p className='text-[#1D1C1F] text-[20px] font-semibold'>{paymentMade?.length}</p>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-7'>
                                <p className='text-[20px] text-[#302F33]'>Transactions</p>
                                <div className='grid grid-cols-3 gap-5 py-3 border-b border-b-black/50 text-[#525154]'>
                                    <p>Payment Date</p>
                                    <p>Payment type</p>
                                    <div className='flex items-center justify-between mr-5'>
                                        Amount
                                        <p className='font-semibold invisible text-[18px] text-black/60 cursor-pointer'>
                                            <img src={menus} alt="" />
                                        </p>
                                    </div>
                                </div>
                                {paymentMade.map((payment, index) => (
                                    <div
                                        key={payment.id || index}
                                        className='grid grid-cols-3 gap-5 py-3 border-b border-b-black/50 text-[#525154]'
                                    >
                                        <p>{new Date(payment.date_created).toLocaleDateString()}</p>
                                        <p className='truncate'>
                                            {payment.account_type === 'crypto' ? payment.cryptocurrency_type : 'Bank Transfer'}
                                        </p>
                                        <div className='flex items-center justify-between mr-5'>
                                            ${payment.amount}
                                            <p className='font-semibold text-[18px] text-black/60 cursor-pointer'>
                                                <img src={menus} alt="" />
                                            </p>
                                        </div>
                                    </div>
                                ))}
                                <p className='text-[#78757A] mt-3'>
                                    {paymentMade?.length} {paymentMade?.length > 1 ? 'items' : 'item'}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className='mt-7 border rounded-lg p-5 flex flex-col gap-3'>
                                <p className='text-[18px] font-medium text-[#302F33]'>Summary</p>
                                <div className='flex justify-between'>
                                    <div className='flex flex-col gap-2'>
                                        <p className='text-[#525154]'>Amount Sent</p>
                                        <p className='text-[#1D1C1F] text-[20px] font-semibold'>0</p>
                                    </div>
                                    <div className='flex flex-col gap-2'>
                                        <p className='text-[#525154]'>Number of Transactions</p>
                                        <p className='text-[#1D1C1F] text-[20px] font-semibold'>0</p>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-7 border-2 border-black/30 bg-[#F9F7FC] border-dashed rounded-lg p-9 flex flex-col gap-6'>
                                <p className='text-[20px] font-medium text-center'>No transactions yet</p>
                                <button className='bg-[#531CB3] text-white py-[10px] mx-auto px-4 rounded-lg'>Create Invoice</button>
                            </div>
                        </div>
                    )}
                </>
            )}
            <SendBarFromBeneficiary Benficiary={Benficiary.account_type} setSendErrorBar={setSendErrorBar} setOpenSendBar={setOpenSendBar} />
        </div>
    )
}

export default ViewDetailsBar